// Shared apparel readiness gate; each product declares its own artwork and mockup requirements.
const config = JSON.parse(document.getElementById('np-apparel-config')?.textContent || 'null');
const body = document.body;
let revealTimer = null;
let frame = null;
let listeners = null;
let timeout = null;
let stickyHeader = null;
let headerFrame = null;
const headerObserver = new ResizeObserver(syncStickyHeader);
const observer = new MutationObserver(schedule);
function syncStickyHeader() {
  const gallery = document.querySelector('.product-information__media media-gallery');
  const header = document.querySelector('.nr-header-section');
  if (!gallery) return;
  const rect = header?.getBoundingClientRect();
  const height = Math.ceil(rect?.height ?? 0);
  const value = `${height}px`;
  if (gallery.style.getPropertyValue('--np-preview-header-height') !== value) {
    gallery.style.setProperty('--np-preview-header-height', value);
  }
  const offset = `${Math.max(0, Math.min(height, Math.ceil(rect?.bottom ?? 0)))}px`;
  if (gallery.style.getPropertyValue('--np-preview-header-offset') !== offset) {
    gallery.style.setProperty('--np-preview-header-offset', offset);
  }
  if (header !== stickyHeader) {
    headerObserver.disconnect();
    stickyHeader = header;
    if (header) headerObserver.observe(header);
  }
}
function scheduleStickyHeader() {
  if (headerFrame !== null) return;
  headerFrame = requestAnimationFrame(() => {
    headerFrame = null;
    syncStickyHeader();
  });
}
function schedule() {
  if (frame !== null) return;
  frame = requestAnimationFrame(() => { frame = null; inspect(); });
}
function prepared() {
  const gallery = document.querySelector('.product-information__media #tee-gallery');
  const artwork = document.getElementById('tee-artwork-' + config?.artworkId);
  const mockup = gallery?.querySelector('.tee-slide--active .tee-mockup-item--loaded');
  if (!mockup || !artwork || artwork.querySelectorAll('g.tee-layer-image svg').length < (config?.ready.images ?? 0)) return false;
  const photos = Array.from(mockup.querySelectorAll('.tee-printarea--image img'));
  if (photos.length < (config?.ready.photos ?? 1) || photos.some(image => !image.complete || image.naturalWidth === 0)) return false;
  const masks = Array.from(artwork.querySelectorAll('mask image'));
  if (masks.length < (config?.ready.masks ?? 0) || masks.some(image => !(image.getAttribute('href') || '').startsWith('blob:'))) return false;
  return document.fonts.status === 'loaded';
}
function inspect() {
  syncStickyHeader();
  clearTimeout(revealTimer);
  const ready = prepared();
  const gallery = document.querySelector('.product-information__media media-gallery');
  gallery?.setAttribute('aria-busy', ready ? 'false' : 'true');
  if (!ready) {
    if (body.dataset.npPreview === 'ready') body.dataset.npPreview = 'loading';
    return;
  }
  if (body.dataset.npPreview === 'ready') return;
  // A short stable render window avoids exposing partially assembled masks.
  revealTimer = setTimeout(() => {
    if (prepared()) { body.dataset.npPreview = 'ready'; clearTimeout(timeout); }
  }, 160);
}
function start() {
  if (listeners && !listeners.signal.aborted) return;
  listeners = new AbortController();
  observer.observe(document.documentElement, {childList: true, subtree: true});
  document.addEventListener('load', schedule, {capture: true, signal: listeners.signal});
  // The retail shell scrolls internally; capture also covers window scrolling.
  document.addEventListener('scroll', scheduleStickyHeader, {capture: true, passive: true, signal: listeners.signal});
  document.fonts.addEventListener('loadingdone', schedule, {signal: listeners.signal});
  timeout = setTimeout(() => {
    if (body.dataset.npPreview !== 'ready') body.dataset.npPreview = 'error';
  }, 15000);
  schedule();
}
function stop() {
  observer.disconnect(); listeners?.abort();
  headerObserver.disconnect(); stickyHeader = null;
  clearTimeout(revealTimer); clearTimeout(timeout);
  if (frame !== null) cancelAnimationFrame(frame);
  if (headerFrame !== null) cancelAnimationFrame(headerFrame);
  frame = null;
  headerFrame = null;
}
start();
window.addEventListener('pagehide', stop);
window.addEventListener('pageshow', start);
